(function () {
    'use strict';

    var module = angular.module('uwAgenda.tasks');
    /* directive for handling task reactions */
    module.directive('taskReactionList', [function () {
        var directive = {
            restrict: 'E',
            templateUrl: '/app/tasks/templates/task-reaction-list.template.html'
        };
        return directive;
    }]);
})();